import { ExecutiveDashboardService } from '#services/executive-dashboard/executive-dashboard.interface';
import { ExecutiveReportService } from '#services/executive-report/executive-report.interface';
import { InjectionToken } from '@angular/core';

export enum APP_TOKENS_ENUM {
  EXECUTIVE_DASHBOARD = 'EXECUTIVE_DASHBOARD',
  EXECUTIVE_REPORT = 'EXECUTIVE_REPORT'
}

export interface AppTokensConstant {
  EXECUTIVE_DASHBOARD: InjectionToken<ExecutiveDashboardService>;
  EXECUTIVE_REPORT: InjectionToken<ExecutiveReportService>;
}

export const APP_TOKENS: AppTokensConstant = {
  EXECUTIVE_DASHBOARD: new InjectionToken<ExecutiveDashboardService>(APP_TOKENS_ENUM.EXECUTIVE_DASHBOARD),
  EXECUTIVE_REPORT: new InjectionToken<ExecutiveReportService>(APP_TOKENS_ENUM.EXECUTIVE_REPORT)
};
